import { ComponentClass, StatelessComponent } from 'react';

type Component<P> = ComponentClass<P> | StatelessComponent<P>;

export interface IHighOrderComponentDecorator<TParentProps, TChildProps> {
  (component: Component<TChildProps>): Component<TParentProps>;
}

interface IComponentContainerBuilder<TParentProps> {
  pipe<TChildProps>(
    decorator: IHighOrderComponentDecorator<TParentProps, TChildProps>
  ): IComponentContainerBuilderNext<TParentProps, TChildProps>;
}

interface IComponentContainerBuilderNext<TParentProps, TChildProps> {
  pipe<TGrandChildProps>(
    decorator: IHighOrderComponentDecorator<TChildProps, TGrandChildProps>
  ): IComponentContainerBuilderNext<TParentProps, TGrandChildProps>;
  build(component: Component<TChildProps>): Component<TParentProps>;
}

function continueComponentContainer<TParentProps, TChildProps>(
  parentDecorator: IHighOrderComponentDecorator<TParentProps, TChildProps>
) {
  return {
    pipe<TGrandChildProps>(
      decorator: IHighOrderComponentDecorator<TChildProps, TGrandChildProps>
    ): IComponentContainerBuilderNext<TParentProps, TGrandChildProps> {
      return continueComponentContainer<TParentProps, TGrandChildProps>((
        component: Component<TGrandChildProps>
      ): Component<TParentProps> => {
        return parentDecorator(decorator(component));
      });
    },
    build(component: Component<TChildProps>): Component<TParentProps> {
      return parentDecorator(component);
    },
  };
}

export function createComponentContainer<TParentProps>(): IComponentContainerBuilder<TParentProps> {
  return {
    pipe<TChildProps>(
      decorator: IHighOrderComponentDecorator<TParentProps, TChildProps>
    ): IComponentContainerBuilderNext<TParentProps, TChildProps> {
      return continueComponentContainer<TParentProps, TChildProps>(decorator);
    },
  };
}



// WEBPACK FOOTER //
// ./src/utils/hoc.ts